import type { Translate } from "@/app/localization";

// Work-mode codes contain hyphens, which catalog enum values cannot, so each
// known code has its own key; the code itself keeps driving the toggle and the PATCH.
const WORK_MODE_KEY: Record<string, string> = {
  "plug-and-charge": "operator.unit.work_mode_plug_and_charge",
  "commercial-public": "operator.unit.work_mode_commercial_public",
};

/** Display label of a unit work_mode code; an unknown code is shown raw. */
export function workModeLabel(t: Translate, mode: string): string {
  const key = WORK_MODE_KEY[mode];
  return key ? t(key) : mode;
}
